module.exports = __webpack_public_path__ + "static/media/undraw_data.b7e6dc87.svg";